import { MonthlyBucket, MonthlyRuleId } from './api';
import { MONTHLY_RULES } from './monthlySimpleMath';

export interface MonthlyTariffOption {
  value: MonthlyRuleId;
  label: string;
  unit: string;
  rate: number | null;
  fixed: boolean;
}

const labels: Partial<Record<MonthlyRuleId, string>> = {
  voice: 'Calls', sms: 'SMS', email: 'Email', sms_email: 'SMS + email',
  mailbox: 'Mailbox monitoring', processing_heavy: 'Document-heavy processing',
  processing_light: 'Light processing', generated_document: 'Generated documents',
  platform_500: 'Platform · single system', platform_750: 'Platform · multiple systems',
  platform_850: 'Platform · complex integrations', hosting_500: 'Hosting · standard',
  hosting_750: 'Hosting · private', ap_unlimited: 'Invoice processing · unlimited',
  secondary_unlimited: 'Secondary processing · unlimited', payroll: 'Payroll',
  third_party: 'Third-party costs', third_party_record: 'Third-party records · cost + 20%',
};

/** Policy choices expose their established rates; phase agreements stay manual. */
export function monthlyTariffOptions(bucket: MonthlyBucket): MonthlyTariffOption[] {
  return (Object.keys(labels) as MonthlyRuleId[]).filter(value => MONTHLY_RULES[value].bucket === bucket).map(value => ({
    value, label: labels[value]!, unit: MONTHLY_RULES[value].unit,
    rate: MONTHLY_RULES[value].rate, fixed: !!MONTHLY_RULES[value].fixed,
  }));
}
